import { UserTeamsPayload } from 'components/usersTable/types';
import { UserTeam, Team } from 'contexts/teams/types';
import { LicenseAddon } from 'contexts/users/types';
import { applySkillDiveDependency } from 'utils/invites';

// An existing user's access before the team modal's changes.
export interface ExistingUserAccess {
  /** The user's id, which the add-on endpoint takes. */
  user: string;
  /** To tell whether the row is the signed-in user. */
  uaa_id?: string;
  /** Whether the user is a Team Manager. */
  is_team_manager?: boolean;
  has_license: boolean;
  license_addons: LicenseAddon[];
  /** All their teams; setting teams replaces them all. */
  teams: UserTeamsPayload[];
}

export interface Invite {
  email: string;
  is_account_owner?: boolean;
  is_manager: boolean;
  has_license: boolean;
  // Forced off whenever has_license is turned off.
  has_skill_dive?: boolean;
  team?: string;
  id?: string;
  teams?: UserTeamsPayload[];
  userTeams?: UserTeam[];
  // Existing users only: name, avatar and current access.
  name?: string;
  avatar?: string;
  existing?: ExistingUserAccess;
}

export interface SetInvites {
  emailInvite: string;
  invites: Invite[];
  action: 'setRole' | 'setLicense' | 'setAccountRole';
  value: boolean;
}

export interface InvitesBatch {
  message: string;
  team?: string;
  teams?: UserTeamsPayload[];
  invites: Invite[];
  detail?: string;
  account?: string;
}

export const setInviteData = ({ invites, emailInvite, action, value }: SetInvites): Invite[] => {
  const inviteIndex = invites.findIndex(({ email }) => email === emailInvite);
  const newInvites = invites;
  if (action === 'setRole') {
    newInvites[inviteIndex].is_manager = value;
  } else if (action === 'setLicense') {
    newInvites[inviteIndex].has_license = value;
  } else if (action === 'setAccountRole') {
    newInvites[inviteIndex].is_account_owner = value;
  }
  return newInvites;
};

interface InvitesAction {
  type: 'SET_EMAIL_INVITES' | 'SET_TEAM' | 'SET_MESSAGE';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const invitesReducer = (state: InvitesBatch, action: InvitesAction): InvitesBatch => {
  if (action.type === 'SET_EMAIL_INVITES' && (action.value as Invite[])) {
    return { ...state, invites: applySkillDiveDependency(action.value as Invite[]) };
  } else if (action.type === 'SET_TEAM') {
    return { ...state, teams: action.value };
  } else if (action.type === 'SET_MESSAGE') {
    return { ...state, message: action.value };
  } else {
    return state;
  }
};

// para pasar objeto a array cada vez que seteo el nuevo state
// let array2 = array.map(a => {return {...a}})
